import backendRedirect from '../../backendRedirect'
import {getDevServer, getDevServerRoot} from '../devMode'

const defaultServerWithoutRoot = backendRedirect.apiTrafficManager
const devServerWithoutRoot = getDevServer('parallels', defaultServerWithoutRoot) // works b/c default url -
const devServerRoot = getDevServerRoot('parallels') // - i.e. apiTrafficManager - has NO "path" (e.g. "/server")
const serverRoot1 = devServerRoot || '/parallels' // note the url in the file must EXCLUDE "/api" - 
const serverRoot2 = '/api' // - which makes sense b/c the call to "output" doesn't use that
const serverUrl = (devServerWithoutRoot || defaultServerWithoutRoot) + serverRoot1 + serverRoot2
const outputUrl = (devServerWithoutRoot || defaultServerWithoutRoot) + serverRoot1 + '/Output'
const visualizerUrl = '/visualizer/api/visualize'

//const visualizerUrl = '/visualize'

const talmudServerUrl = 'https://talmudsearch.dicta.org.il/api/search'
const tanachSearchServerUrl = 'https://search.dicta.org.il/api/search'

export const StoreConfig = {
  serverRoot: serverRoot2, // for api child handler - see router.js
  serverUrl: serverUrl,
  outputUrl: outputUrl, // actually not currently used at all in parallels finder
  visualizerUrl: visualizerUrl,
  talmudServerUrl: talmudServerUrl,
  tanachSearchServerUrl: tanachSearchServerUrl
}
